import { Layout } from "@/layout";
import { FormPage, NotFoundPage, ThankYouPage } from "@/pages";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import z from "zod";
import { register as registerZodMetadata } from "zod-metadata";

registerZodMetadata(z);

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route path="/thanks" element={<ThankYouPage />} />
          <Route path="/:formId" element={<FormPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
